import styled from '@emotion/styled';
import { Grid as SemanticGrid, GridColumn } from 'semantic-ui-react';

export const Grid = styled(SemanticGrid)`
	margin: 0 !important;
`;

export const Column = styled(GridColumn) `
	padding: 16px !important;
	margin: 0px !important;

	&:first-child {
		padding-right: 0px !important;
	}
`;
